// extracted by mini-css-extract-plugin
module.exports = {"skeleton__wrapper":"Skeleton_skeleton__wrapper__3n2Bp","skeleton__aside":"Skeleton_skeleton__aside__22sE_","skeleton__main":"Skeleton_skeleton__main__2PMAz"};